<td class="service-col">
  {{ getServiceName() }}
</td>

<td class="status-col" [ngSwitch]="log.status">
  <mat-icon *ngSwitchCase="'SUCCESS'" color="primary">check_circle</mat-icon>
  <mat-icon *ngSwitchCase="'ERROR'" style="color: red">cancel</mat-icon>
  <mat-icon *ngSwitchDefault color="disabled">help_outline</mat-icon>
</td>

<td class="info-col">
  <mat-icon [matTooltip]="log.message" class="help-icon"> info </mat-icon>
</td>
